/*
 * @Author: yejianfei
 * @Date: 2023-04-03 18:03:26
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-11 13:59:43
 * @Description:
 * @Developer:
 */
import { createFromIconfontCN } from '@ant-design/icons';
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_3959742_kuqo7sl16oq.js',
});
export default IconFont;
